export default __webpack_public_path__ + "static/catalin-ciochina-0f2f2832dfed7402bd3029055e75a754.svg";